import { render, staticRenderFns } from "./SwitchCookie.vue?vue&type=template&id=4b73c712&"
import script from "./SwitchCookie.vue?vue&type=script&lang=js&"
export * from "./SwitchCookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports